import React from 'react';

const StatusMessage = ({ type, message, isLoading = false, className = '' }) => {
    if (!message && !isLoading) return null;

    const getAlertClass = () => {
        switch (type) {
            case 'success':
                return 'alert-success';
            case 'error':
                return 'alert-danger';
            case 'info':
                return 'alert-info';
            case 'warning':
                return 'alert-warning';
            default:
                return 'alert-info';
        }
    };

    if (isLoading) {
        return (
            <div className={`alert alert-info d-flex align-items-center ${className}`}>
                <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                {message || 'Loading...'}
            </div>
        );
    }

    return (
        <div className={`alert ${getAlertClass()} ${className}`}>
            {message}
        </div>
    );
};

export default StatusMessage;